// extracted by mini-css-extract-plugin
export default {"competitions":"Competitions_competitions__uhekQ","name":"Competitions_name__LEVBx","columns11":"Competitions_columns11__doaOO","columns21":"Competitions_columns21__oXXIO"};